<template>
  <InputComponent v-bind="$attrs">
    <RichTextComponent v-model="comp" :disabled="$attrs.disabled" :commands="$attrs.commands" />
  </InputComponent>
</template>

<script>
import { InputComponent } from 'vue-elder-input'
import RichTextComponent from '@kvass/rich-text'

import { ValueComp } from '../utils'

export default {
  props: ['value', 'default'],
  computed: {
    comp: ValueComp(),
  },

  created() {
    let hasDefaultProp = 'default' in this.$options.propsData

    if (hasDefaultProp && this.value === undefined) this.comp = this.default
  },
  components: {
    InputComponent,
    RichTextComponent,
  },
}
</script>
